const routes = {
  getVehicleList: 'gatepass/vehicles',
  getGatePassVehicleApprovals: 'gatepass/vehicles/approvals',
  requestGatePass: 'gatepass/request',
  approveStatus: 'gatepass/approvalStatus',
  getGatePassDetails: 'gatepass/details',
  createGatePass: 'gatepass/create',
  payGatePass: 'gatepass/pay',
  updateInOutStatus: 'gatepass/inOutStatus',
  getMobaya: 'gatepass/mobaya',
  issueMobaya: 'gatepass/issueMobaya',
  getGatePassList:'gatepass/internals',
  getGatePassPreview:'gatepass/preview'
};

export default routes